import React from "react";
import { Row, Col, Tabs, Select, Radio, Button, Modal, Tooltip, Icon } from "antd";

import "./TransferDetailsPanel_new.scss";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { formatMoney, formatExchangeRate, getCountryCodeForCurrency } from "utils/utils";
import { displayNumberWithComma } from "../../utils/utils";
import FieldValueSignUpVerticalCell from "../general/FieldValueSingUpVerticalCell";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import config from "../../config";
import { displayError } from "../../common/notifications";
import CurrencySelector from "../CurrencySelector_new";
import ReactCountryFlag from "react-country-flag";

const { TabPane } = Tabs;

class TransferDetailsPanel extends React.Component {
  state = {
    activeTabFee: this.props.transfer ? this.props.transfer.activeTabFee || 'local' : 'local',
    swiftOur: this.props.transferRoute ? this.props.transferRoute.swiftOur : null,
    swiftBen: this.props.transferRoute ? this.props.transferRoute.swiftBen : null,
    swiftSha: this.props.transferRoute ? this.props.transferRoute.swiftSha : null,
    dbsChargeBearer: this.props.transfer ? this.props.transfer.dbsChargeBearer || 'SHAR' : 'SHAR',
    showSwift: false,
    showFee: null,
    showModal: false,
    selectedChargeOption: 'SHAR',
    dbsChargeBearer: 'SHAR', 
    chargeOptions: {
      'SHAR': 'SHA',
      'DEBT': 'OUR',
      'CRED': 'BEN'
    }
  };

  componentDidMount() {
    this.initData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.transferRoute.swiftSha !== this.state.swiftSha
      || prevProps.transferRoute.swiftBen !== this.state.swiftBen
      || prevProps.transferRoute.swiftOur !== this.state.swiftOur
    ) {
      this.initData();
    }
    if (this.props.fee !== prevProps.fee) {
      if (this.props.transferRoute.swiftBen || this.props.transferRoute.swiftSha
        || this.props.transferRoute.swiftOur) {
        this.props.updateSourceTargetAfterChangeFee();
      }
    }
    if ((this.state.activeTabFee === 'swift' || this.state.activeTabFee === undefined) && !prevProps.transferRoute.allowSwiftFee && prevProps.transferRoute.allowLocalPayout) {
      this.setState({
        activeTabFee: 'local'
      }, () => {
        this.props.updatePaymentActiveTabFee(this.state.activeTabFee);
      });
    } else if ((this.state.activeTabFee === 'local' || this.state.activeTabFee === undefined) && prevProps.transferRoute.allowSwiftFee && !prevProps.transferRoute.allowLocalPayout) {
      this.setState({
        activeTabFee: 'swift',
      }, () => {
        this.props.updatePaymentActiveTabFee(this.state.activeTabFee);
      });
    } else if (this.state.activeTabFee !== undefined && !prevProps.transferRoute.allowSwiftFee && !prevProps.transferRoute.allowLocalPayout) {
      this.setState({
        activeTabFee: undefined
      }, () => {
        this.props.updatePaymentActiveTabFee(this.state.activeTabFee);
      });
    } else if (this.props.transferRoute.allowSwiftFee && this.props.transferRoute.allowLocalPayout) {
      let sourceValue = this.props.sourceValue;
      let targetValue = this.props.targetValue;
      if ((sourceValue && sourceValue.currency !== prevProps.sourceValue.currency)
        || (targetValue && targetValue.currency !== prevProps.targetValue.currency)
      ) {
        this.initData();
      }
    }
  }

  initData = () => {
    // Existing initData logic...
    let dbsChargeBearer = 'SHAR';
    let activeTabFee = this.state.activeTabFee;

    let swiftSha = this.props.transferRoute.swiftSha;
    let swiftBen = this.props.transferRoute.swiftBen;
    let swiftOur = this.props.transferRoute.swiftOur;

    let feeArr = [];
    feeArr.push({ type: "SHAR", fee: swiftSha });
    feeArr.push({ type: "CRED", fee: swiftBen });
    feeArr.push({ type: "DEBT", fee: swiftOur });

    let fee = this.props.fee;
    if (!this.props.transferRoute.allowPayoutLocal && this.props.transferRoute.allowSwiftFee) {
      feeArr = feeArr.filter(item => item.fee && item.fee !== 0).sort((a, b) => a.fee - b.fee);
      if (swiftSha && swiftSha !== 0) {
        fee = swiftSha;
      } else if (swiftBen && swiftBen !== 0) {
        fee = swiftBen;
      } else if (swiftOur && swiftOur !== 0) {
        fee = swiftOur;
      }
    }
    let minFee = fee;

    if (swiftSha != null || swiftBen != null || swiftOur != null) {
      // showSwift=true;
    } else {
      activeTabFee = 'local';
      // showSwift=false;
    }
    if (swiftSha != null && swiftSha < minFee) {
      minFee = swiftSha;
      activeTabFee = 'swift';
      dbsChargeBearer = 'SHAR';
    }

    if (swiftBen != null && swiftBen < minFee) {
      minFee = swiftBen;
      dbsChargeBearer = 'CRED';
      activeTabFee = 'swift';
    }

    if (swiftOur != null && swiftOur < minFee) {
      minFee = swiftOur;
      dbsChargeBearer = 'DEBT';
      activeTabFee = 'swift';
    }

    if (activeTabFee === 'swift') {
      if (dbsChargeBearer === 'SHAR' && (!swiftSha || swiftSha === 0)) {
        if (feeArr.length > 0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      } else if (dbsChargeBearer === 'CRED' && (!swiftBen || swiftBen === 0)) {
        if (feeArr.length > 0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      } else if (dbsChargeBearer === 'DEBT' && (!swiftOur || swiftOur === 0)) {
        if (feeArr.length > 0) {
          dbsChargeBearer = feeArr[0].type;
          minFee = feeArr[0].fee;
        }
      }
    }

    this.setState({
      swiftOur: swiftOur,
      swiftBen: swiftBen,
      swiftSha: swiftSha,
      dbsChargeBearer: dbsChargeBearer,
      activeTabFee: activeTabFee,
      minFee: minFee,
      swiftFee: minFee,
      selectedChargeOption: dbsChargeBearer
    }, () => {
      let swiftFee = this.state.swiftFee;
      this.props.updateSwiftFee(swiftFee, this.state.activeTabFee, this.state.dbsChargeBearer)
    })
  }

  changeChargeOps = (value) => {
    let swiftSha = this.props.transferRoute.swiftSha;
    let swiftBen = this.props.transferRoute.swiftBen;
    let swiftOur = this.props.transferRoute.swiftOur;

    let swiftFeeTmp = swiftSha;
    if (value === 'SHAR') {
      swiftFeeTmp = swiftSha;
    } else if (value === 'DEBT') {
      swiftFeeTmp = swiftOur;
    } else if (value === 'CRED') {
      swiftFeeTmp = swiftBen;
    }

    this.setState({
      dbsChargeBearer: value,
      swiftFee: swiftFeeTmp,
      selectedChargeOption: value
    }, () => {
      let swiftFee = this.state.swiftFee;
      this.props.updateSwiftFee(swiftFee, this.state.activeTabFee, this.state.dbsChargeBearer);
    })
  }

  showModal = () => {
    this.setState({ showModal: true });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  handleModalOk = () => {
    this.changeChargeOps(this.state.selectedChargeOption);
    this.hideModal();
  };

  handleChargeOptionChange = (e) => {
    this.setState({ selectedChargeOption: e.target.value });
  }

  formatFee = fee => {
    return formatMoney(fee) + " " + (this.props.transferRoute ? this.props.transferRoute.feeCurrency : this.props.sourceValue.currency);
    // return formatMoney(fee) + " " +  this.props.sourceValue.currency;
  };

  render() {
    const intl = this.props.useIntl;
    let localActive = this.state.activeTabFee === 'local';
    let swiftActive = this.state.activeTabFee === 'swift';

    let colFee = {
      border: '1px solid #dddddd',
      textAlign: 'left',
      padding: '10px 5px'
    }

    let colFeeCenter = {
      border: '1px solid #dddddd',
      textAlign: 'center',
      padding: '10px 5px'
    }

    let styleSwiftActive = swiftActive ? this.enableBtn : null;
    let styleLocalActive = localActive ? this.enableBtn : null;

    // Use the correct fee value based on activeTabFee and dbsChargeBearer
    let propsFree = this.state.activeTabFee === 'swift' && this.state.dbsChargeBearer === 'SHAR'
      ? this.state.swiftSha
      : this.props.fee || 0;
    let convertedAmount = this.props.sourceValue.amount - propsFree;
    let swiftCurrency = (this.props.transferRoute && this.props.transferRoute.feeCurrency) ? this.props.transferRoute.feeCurrency : this.props.sourceValue.currency;
    let activeSwiftSHA = this.state.activeTabFee === 'swift' && this.state.dbsChargeBearer === 'SHAR';

    let shaDisabled = !this.state.swiftSha || this.state.swiftSha == 0;
    let ourDisabled = !this.state.swiftOur || this.state.swiftOur == 0;
    let benDisabled = !this.state.swiftBen || this.state.swiftBen == 0;

    // Get the label for the currently selected charge option
    const chargeOptionLabel = this.state.chargeOptions[this.state.dbsChargeBearer];

    return (
      <div>
        <Row className={'row-active-fee'} justify="center">
          <Col sm={24} lg={12} md={12}>
            <div className="local-swift-button-header" style={{ textAlign: 'left', width: '100%', marginBottom: "10px" }}>
              <b>
                {intl.formatMessage({ id: "app.panel.transferdetailspanel.modeofpayment" })}
                <Tooltip title="Select Local Payout for domestic transfers or SWIFT for international transfers." >
                  <Icon type="info-circle" />
                </Tooltip>
              </b>
            </div>
            <Row className="local-swift-button" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

              <Col sm={12} span={12} className={'gutter-row'}>
                <Button
                  disabled={!this.props.transferRoute.allowLocalPayout}
                  onClick={() => {
                    if (swiftActive) {
                      this.setState({
                        activeTabFee: 'local'
                      }, () => {
                        this.props.updateSwiftFee(this.state.swiftFee, this.state.activeTabFee, this.state.dbsChargeBearer);
                      })
                    }
                  }}
                  icon={localActive ? 'check' : ''}
                  style={{ ...styleLocalActive, width: '100%', border: '1px solid #0a9eb2' }}
                >
                  {intl.formatMessage({ id: "app.panel.transferdetailspanel.local.fee" })}
                </Button>
              </Col>
              <Col sm={12} span={12}>
                <Button
                  disabled={!this.props.transferRoute.allowSwiftFee}
                  onClick={() => {
                    if (localActive) {
                      this.setState({
                        activeTabFee: 'swift',
                      }, () => {
                        let fee = propsFree;
                        if (this.state.dbsChargeBearer) {
                          if (this.state.swiftFee != null) {
                            fee = this.state.swiftFee;
                          }
                        }
                        this.props.updateSwiftFee(fee, this.state.activeTabFee, this.state.dbsChargeBearer);
                      })
                    }
                  }}
                  icon={this.state.activeTabFee === 'swift' ? 'check' : ''}
                  style={{ ...styleSwiftActive, width: '100%', border: '1px solid #0a9eb2' }}
                >
                  {intl.formatMessage({ id: "app.panel.transferdetailspanel.swift.fee" })}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ marginTop: "14px" }}>
          <Col span={24} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {this.state.activeTabFee === 'swift' && (
              <div style={{ margin: '14px auto', width: '100%', maxWidth: '400px' }} className="main-charge-option">
                <div className="charge-option-header" style={{ textAlign: 'left', width: '100%' }}>
                  <b>
                    {intl.formatMessage({ id: "app.panel.transferdetailspanel.charge.option" })}
                    <Tooltip title="Select how transaction fees are applied: SHA (Shared) - You and the recipient share the fees. OUR (Sender) - You pay all fees">
                      <Icon type="info-circle" />
                    </Tooltip>
                  </b>
                </div>
                <div className="charge-option-container-outside-modal">
                  <div className="charge-option" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Radio checked enabled>
                      <span style={{ fontSize: '16px' }}>{chargeOptionLabel}</span>
                    </Radio>
                  </div>
                  <Button onClick={this.showModal} className="change-button-fee">Change</Button>
                </div>
                <Modal
                  title={<span style={{ fontFamily: 'Roboto, sans-serif', fontSize: '14px' }}>Select your preferred charge option:</span>}
                  visible={this.state.showModal}
                  onOk={this.handleModalOk}
                  onCancel={this.hideModal}
                  className="rounded-modal"

                >
                  <div className="charge-option-modal">
                    <div className="charge-option-container">
                      <div className="charge-option-header">
                        <Radio
                          value="SHAR"
                          checked={this.state.selectedChargeOption === 'SHAR'}
                          onChange={this.handleChargeOptionChange}
                        >
                          <span className="charge-option-title">SHA</span>
                        </Radio>
                      </div>
                      <div className="charge-option-details">
                        <div>Both sender and recipient share transaction fees.</div>
                        <div>Transfer Fee: {this.state.swiftSha ? this.formatFee(this.state.swiftSha) : 'N/A'}</div>
                      </div>
                    </div>
                    <div className="charge-option-container">
                      <div className="charge-option-header">
                        <Radio
                          value="DEBT"
                          checked={this.state.selectedChargeOption === 'DEBT'}
                          onChange={this.handleChargeOptionChange}
                        >
                          <span className="charge-option-title">OUR</span>
                        </Radio>
                      </div>
                      <div className="charge-option-details">
                        <div>The sender pays all transaction fees.</div>
                        <div>Transfer Fee: {this.state.swiftOur ? this.formatFee(this.state.swiftOur) : 'N/A'}</div>
                      </div>
                    </div>
                    <div className="charge-option-container">
                      <div className="charge-option-header">
                        <Radio
                          value="CRED"
                          checked={this.state.selectedChargeOption === 'CRED'}
                          onChange={this.handleChargeOptionChange}
                        >
                          <span className="charge-option-title">BEN</span>
                        </Radio>
                      </div>
                      <div className="charge-option-details">
                        <div>The recipient pays all transaction fees.</div>
                        <div>Transfer Fee: {this.state.swiftBen ? this.formatFee(this.state.swiftBen) : 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            )}
          </Col>
        </Row>

        <Row style={{ marginTop: "14px" }}>
          <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '400px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>Transfer Fees: </span>
                <span>{this.formatFee(propsFree)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>Transfer Amount: </span>
                <span>{displayNumberWithComma(this.props.sourceValue.amount)} {this.props.sourceValue.currency}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 'bold' }}>Amount Converted: </span>
                <span>{convertedAmount == 0 ? "0.00" : displayNumberWithComma(convertedAmount)} {this.props.sourceValue.currency}</span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withUseIntl(TransferDetailsPanel);